import { useContext, ReactNode } from 'react';
import { AccordionPanelWrapper } from './AccordionCollapsibleMobile.styled';
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
} from '@fluentui/react-components';
import { TeamsFxContext } from 'src/context/TeamsContext';

interface AccordionCollapsibleProps {
  title: string;
  children: ReactNode;
}

export const AccordionCollapsibleMobile = ({
  title,
  children,
}: AccordionCollapsibleProps) => {
  const { isMobile } = useContext(TeamsFxContext);

  return (
    <>
      {isMobile && (
        <Accordion collapsible>
          <AccordionItem value="1">
            <AccordionHeader>{title}</AccordionHeader>
            <AccordionPanelWrapper>
              <AccordionPanel>{children}</AccordionPanel>
            </AccordionPanelWrapper>
          </AccordionItem>
        </Accordion>
      )}
      {!isMobile && <>{children}</>}
    </>
  );
};
